






























































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { getBiduiYanse } from "@/request/idr";
@Component({})
export default class IdrBiduiYanse extends Vue {
  @Prop()
  private tongues: any;
  private loaded: boolean = false;
  private filters: any = {
    类别: "舌色",
    部位: "全舌",
    色彩: "LAB"
  };
  private message: any = {};
  private tubiao: any = {
    // title: {
    //   textStyle: {
    //     color: "#333333",
    //     fontSize: 14,
    //     fontWeight: "normal"
    //   }
    // },
    legend: {
      orient: "vertical",
      left: "0%",
      top: "10%",
      itemGap: 80
    },
    grid: [],
    tooltip: {},
    xAxis: [],
    yAxis: [],
    series: []
  };
  private th: any[] = [];
  private tr: any[] = [];
  /**
   * @description 改变类别
   */
  private changeLeilie(leibie) {
    this.filters["类别"] = leibie;
    this.loaded = false;
    this.fetchYanse();
  }
  /**
   * @description 改变位置
   */
  private changeWeizhi(weizhi) {
    this.filters["部位"] = weizhi;
    this.fetchYanse();
  }
  /**
   * @description 改变色彩
   */
  private changeSecai(secai) {
    this.loaded = false;
    this.filters["色彩"] = secai;
    this.fetchYanse();
  }
  /**
   * @description 获得颜色特征
   */
  private fetchYanse() {
    this.loaded = false;
    const ids: any[] = [];
    this.tongues.map((item: any) => {
      ids.push(item.tongue_id);
    });
    const params: any = {
      tongue_ids: ids,
      类别: this.filters["类别"],
      部位: this.filters["部位"],
      色彩: this.filters["色彩"]
    };
    getBiduiYanse(this, params).then((data: any) => {
      this.message = data;
      this.createTubiao();
      this.th = this.message["详细参数列表"].splice(0, 1)[0];
      this.th.splice(0, 1);
      this.tr = this.message["详细参数列表"];
    });
  }
  /**
   * @description 创建图标
   */
  private createTubiao() {
    console.log(this.message["折线图"]);
    this.tubiao.series = [];
    this.tubiao.grid = [];
    this.tubiao.xAxis = [];
    this.tubiao.yAxis = [];
    // this.tubiao.title.text = this.message["折线图名称"];
    let k1 = "";
    let k2 = "";
    let k3 = "";
    if (this.filters["色彩"] === "LAB") {
      k1 = "L";
      k2 = "A";
      k3 = "B";
    } else if (this.filters["色彩"] === "RGB") {
      k1 = "R";
      k2 = "G";
      k3 = "B";
    } else if (this.filters["色彩"] === "HSV") {
      k1 = "H";
      k2 = "S";
      k3 = "V";
    }
    this.message["折线图"].map((item: any, index: any) => {
      this.tubiao.series.push({
        type: "line",
        data: item.data[k1].data,
        xAxisIndex: index * 3,
        yAxisIndex: index * 3,
        smooth: true
      });
      this.tubiao.grid.push({
        show: true,
        borderWidth: 0,
        backgroundColor: "#fff",
        shadowColor: "rgba(0, 0, 0, 0.3)",
        shadowBlur: 2,
        left: "3%",
        top: index * 14 + 2 + "%",
        width: "27%",
        height: "10%"
      });
      this.tubiao.xAxis.push({
        type: "category",
        show: false,
        gridIndex: index * 3
      });
      this.tubiao.yAxis.push({
        type: "value",
        show: false,
        gridIndex: index * 3
      });
      // A
      this.tubiao.series.push({
        type: "line",
        data: item.data[k2].data,
        xAxisIndex: index * 3 + 1,
        yAxisIndex: index * 3 + 1,
        smooth: true
      });
      this.tubiao.grid.push({
        show: true,
        borderWidth: 0,
        backgroundColor: "#fff",
        shadowColor: "rgba(0, 0, 0, 0.3)",
        shadowBlur: 2,
        left: "37%",
        top: index * 14 + 2 + "%",
        width: "27%",
        height: "10%"
      });
      this.tubiao.xAxis.push({
        type: "category",
        show: false,
        gridIndex: index * 3 + 1
      });
      this.tubiao.yAxis.push({
        type: "value",
        show: false,
        gridIndex: index * 3 + 1
      });
      // B
      this.tubiao.series.push({
        type: "line",
        data: item.data[k3].data,
        xAxisIndex: index * 3 + 2,
        yAxisIndex: index * 3 + 2,
        smooth: true
      });
      this.tubiao.grid.push({
        show: true,
        borderWidth: 0,
        backgroundColor: "#fff",
        shadowColor: "rgba(0, 0, 0, 0.3)",
        shadowBlur: 2,
        left: "70%",
        top: index * 14 + 2 + "%",
        width: "27%",
        height: "10%"
      });
      this.tubiao.xAxis.push({
        type: "category",
        show: false,
        gridIndex: index * 3 + 2
      });
      this.tubiao.yAxis.push({
        type: "value",
        show: false,
        gridIndex: index * 3 + 2
      });
    });
    this.loaded = true;
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchYanse();
  }
}
